import noUiSlider from "nouislider"

theme.filter = {

    // The form namespace
    formNamespace   : "form.filter-form:visible",
    // The liquid template namespace
    liquidNamespace : "ajax",
    // Params
    params          : false,
    // Price slider
    priceSliders    : [],
    // Products array
    products        : [],
    // Filter
    html            : null,
    // Product limit
    productLimit    : 24,
    // Products Visible
    productsVisible : 24,
    // Page
    page            : 0,
    // Paginating
    paginating      : false,
    // Promo has run
    promoRan        : false,
    // Sort by modified
    firstRun       : true,

    /**
     * * Filter initialisation
     * Attaches to form element and processes filter
     * @link @https://shopify.dev/themes/navigation-search/filtering
     */
    init: function () {

        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Initialising (1)', 'color: #5fb8ff')
        }

        // Ensure that the grid is filled with more results in a 3x3 grid.
        if ($(window).width() > 1023) {
            this.productLimit       = 24
            this.productsVisible    = 24
        }

        // Containers
        this.ajaxContainer      = $("[data-product-ajax]")
        // Filter container
        this.filterContainer    = $("[data-product-filter]:visible")
        // Faux loader
        this.loadingContainer   = $("[data-product-faux]")
        // Faux loader
        this.intersectContainer = $("#intersect")
        // No results
        this.noResultsContainer = $("[data-product-ajax-empty]")
        // Form
        this.form               = $(this.formNamespace)
        // Collection
        this.collection         = this.form.data("collection")
        // Sort options
        this.sortBy             = $("[data-sort-by]").val()

        // Add listeners
        this.addListeners()
        // Get products
        this.get()
        // Set first run
        this.firstRun = false

    },

    /**
     * * Filter products.
     * @param {*} response
     */
    get: function (resetParams) {

        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Get Products (2)', 'color: #b386df')
        }

        // Get the filtering URL
        let endpoint = this._getFilterUrl(resetParams)

        // Loader handler
        this.loading()

        // Make the request.
        $.ajax({
            url: endpoint,
            success: function (response) {
                let paginatingResults = false
                // Get the response
                response = JSON.parse(response)
                // Set products
                theme.filter.products = response.products
                // Set filter HTML
                theme.filter.html = response.filter
                // Build products
                theme.filter.run(paginatingResults)
                // Update filter HTML
                theme.filter.filterHtml()
            },
            error: function (xhr, err) {
                alert("Error")
            },
        })
    },

    /**
     * * Build latest filter
     *
     */
    filterHtml: function (html) {
        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Update filter HTML (3)', 'color: #e3a693')
        }
        // Reinit accordion.
        // theme.accordion.init()
        // Append the filter html
        this.filterContainer.empty()
        this.filterContainer.html(theme.filter.html)
        // Init the price slider
        this.price()
    },

    /**
     * * Process of results
     * @param {response} AJAX response
     * @returns null
     */
    run: function (paginate) {

        // Only empty if we aren't paginating results.
        if (!paginate) {
            theme.filter.ajaxContainer.empty()
            theme.filter.promoRan = false
        }

        // Catch an empty product array (no results)
        if (theme.filter.products.length == 0) {
            this.noResults()
            return false
        }

        // Slice at the current page
        let data = theme.filter.products.slice(theme.filter.page)

        // Limit the product(s) rendering
        let position = theme.filter.productLimit
        // Show 15 to maintain proper grid (i.e. no missing spaces in 3x3 grid)
        if (theme.filter.promoRan) {
            position = theme.filter.productLimit - 1
        }
        data = data.slice(0, position)

        // Create all product HTML
        let html
        $.each(data, function (index, item) {

            // Generate the 'product' template
            html = theme.filter.template(
                "product",
                item,
                index
            )

            // Append to container
            theme.filter.ajaxContainer.append(html)

            // Add the promo to the grid
            if (!theme.filter.promoRan && index == theme.filter.ajaxContainer.data("promo-index") - 1) {
                // Generate the 'promo' template based on global JSON
                html = theme.filter.template(
                    "promo",
                    theme.product_promo_grid,
                    index
                )
                // Append it to the container at a given point.
                theme.filter.ajaxContainer.append(html)
                // Ensure it only runs once.
                theme.filter.promoRan = true
            }

        })

        // Boot the variant selector <select>.
        theme.variants.init(true)

        // Boot the UI
        this.complete()

        // Reset the pagination flag
        if (paginate) {
            theme.filter.paginating = false
        }

    },

    /**
     * * Template output
     * @param {product} The shopify product
     * @returns html
     */
    template: function (type, data, index) {

        // Get the handlebars html.
        let template = $("#product-box").html()

        // Pass a fallback image to Handlebars.
        let fallback_image = false
        if (type == "product") {
            if (data.product.images.length == 0) {
                fallback_image = theme.fallbackImage
            }
        }

        let costPerDay = false
        if (data.wattage) {
            costPerDay = this.costPerDay(data.wattage);
        }

        // Create a default object for the HTML data
        let object = {
            index             : index,
            product           : data.product,
            price             : this.htmlPrice(data.product),
            fallback_image    : fallback_image,
            penny_image       : theme.pennyImage,
            tag_image_preorder: theme.productTagImages.preOrder,
            tag_image_lowstock: theme.productTagImages.lowStock,
            tag_image_newin   : theme.productTagImages.newIn,
            tag_image_soldout : theme.productTagImages.soldOut,
            colour            : data.colour,
            costPerDay        : costPerDay,
            badge_colour      : this.getBadgecolour(data.product, data.badge_colour),
            badge_text_1      : this.getBadgeText1(data.product, data.badge_text_1),
            badge_text_2      : this.getBadgeText2(data.product, data.badge_text_2)
        }
        // Compile the promo box, changing a few things
        if (type == "promo") {
            template = $("#promo-box").html()
            object = data
        }
        // Compile the template
        let instance = Handlebars.compile(template)
        // Create template
        let output = instance(object)
        // Serve.
        return output
    },

    costPerDay(power) {
        let time = 	theme.costPerDaySettings.averageDays;
        let price = theme.costPerDaySettings.cost;
        let power_multiplier = 1;
        let time_multiplier = 1;
        let total_pence = ((((power*power_multiplier)*(time/time_multiplier))*price)/1000);
        let human_pence = Math.round(total_pence.toFixed(2))
        let cost = human_pence + ' pence';
        if (total_pence < 1.00) {
            cost = 'Less than 1 pence';
        }
        return {
            'human' : cost,
            'percent' : total_pence.toFixed(2) * 100,
            'over1' : (Math.round(total_pence) > 1),
            'over2' : (Math.round(total_pence) > 2),
            'over3' : (Math.round(total_pence) > 3),
            'over4' : (Math.round(total_pence) > 4),
            'over5' : (Math.round(total_pence) > 5),
        };
    },

    // draw_pie_chart() {
    //     let $pie = $('.pie-chart')
    //     $.each($pie, function() {
    //         var percentage,
    //             path,
    //             angle,
    //             radius = 50,
    //             coords = [];
    //         percentage = parseInt($(this).data('percentage'));
    //         angle = percentage * 3.6;
    //         radius = radius * 2;
    //         coords[0] = radius * Math.cos( Math.PI * angle / 180 );
    //         coords[1] = radius * Math.sin( Math.PI * angle / 180 );
    //         path = 'M0,0 L' + radius + ',0 A' + radius + ',' + radius + ' 0 1,1 ' + coords[0] + ',' + coords[1] + ' Z';
    //         $(this).find('path').attr('d', path);
    //     })
    // },

    getBadgeText1(product, text) {

        let text_1 = `Great<br>Price`

        // Age.
        var days = this.product_age(product.created_at)
        if (days > -30) {
            text_1 = `New!`
        } else if (days == 0) {
            text_1 = `New<br>Today!`
        }

        // Saving.
        if (product.compare_at_price > product.price) {
            let discount = (product.compare_at_price - product.price)
            let saving = Shopify.formatMoney(discount)
            if (discount == product.price) {
                text_1 = `50%<br>Off!`
            } else {
                saving = saving.split('.')
                text_1 = `Save<br>${saving[0]}!`
            }
        }

        if (text) {
            text_1 = text
        }

        return text_1
    },

    getBadgeText2(product, text) {

        let text_2 = `Only`

        // Age.
        var days = this.product_age(product.created_at)
        if (days > -30 || days == 0) {
            text_2 = ''
        }

        if (text) {
            text_2 = text
        }

        return text_2
    },

    getBadgecolour(product, colour) {

        let bg = 'red';
        var days = this.product_age(product.created_at)

        if (days > -30) {
            bg = 'green'
        }

        if (colour) {
            bg = colour
        }

        return bg.toLowerCase()
    },

    product_age(date) {
        let created_at = new Date(date)
        let today = new Date()
        let difference = created_at.getTime() - today.getTime();
        var days = Math.ceil(difference / (1000 * 3600 * 24));
        return days;
    },

    htmlPrice(product) {
        let price = Shopify.formatMoney(product.price, "");
        /*if (product.compare_at_price > product.price) {
            price = Shopify.formatMoney(product.compare_at_price, "")
        } else {
            price = Shopify.formatMoney(product.price, "")
        }*/
        price = price.split('.')
        return `${price[0]}<span class="font-light text-xs">.${price[1]}</span>`
    },

    /**
     * * Listeners/events
     * Add listeners to trigger updating of products, etc
     */
    addListeners: function () {

        // Attach to the filtering form.
        $('body').on("submit", this.formNamespace, function (event) {
            event.preventDefault()
            theme.filter.params = $(this).serialize()
            theme.filter.get()
        })

        // Attach to the list item inputs.
        $('body').on("change", ".filter-group-display__list-item input", function (event) {

            $(this)
                .closest(".filter-group-display__list-item")
                .toggleClass("is--active")

            if (!$(this).data("disabled")) {
                $(theme.filter.formNamespace).trigger("submit")
            }

        })

        // Ordering select
        $('body').on("change", "[data-sort-by]", function (event) {
            let sorting = $(event.currentTarget).val()
            $('[data-sort-by]').val(sorting)
            theme.filter.sortBy = sorting
            theme.filter.page = 0
            theme.filter.productsVisible = theme.filter.productLimit
            $(theme.filter.formNamespace).trigger("submit")
            $(document).trigger('filter:data-sorting')
        })

        // Filtering open (mobile only)
        $("[data-filter-open]").on("click", function (e) {
            e.preventDefault()
            let headerHeight = $('[data-header]').outerHeight()
            $("[data-filter-track-footer]").toggleClass("is-active")
            $("[data-filter-menu]").toggleClass("-translate-x-full")
            $("[data-filter-menu]").css({
                'top' : headerHeight,
                'height' : `calc(100% - ${headerHeight}px)`,
                'padding-bottom' : headerHeight*2
            })
            $("body").toggleClass("overflow-hidden modal--open")
            // Misc ui rubbish to clear.
            $('#gorgias-chat-container').toggle();
            $('.kl-teaser-VupZJX').toggle();
        })

        // Filtering close (mobile only)
        $("[data-filter-close]").on("click", function (e) {
            e.preventDefault()
            $("[data-filter-menu]").removeClass("-translate-x-full")
            $("[data-filter-track]").removeAttr("style")
            $("body").removeClass("overflow-hidden modal--open")
        })

        // $("[data-paginate]").on('click', function(e) {
        //     e.preventDefault()
        //     theme.filter.paginating = true
        //     theme.filter._paginate()
        // })

        let obs = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    theme.filter.paginating = true
                    theme.filter._paginate()
                }
            })
        })

        obs.observe(document.getElementById("load-more"))

        $('body').on('click', '[data-filter-reset]', function(e) {
            e.preventDefault()
            let resetParams = $(this).attr('href')
            theme.filter.get(resetParams)
        })

        $(document).on('filter:data-sorting', function(event) {})

    },

    /**
     * * Complete
     */
    complete: function () {

        this.ajaxContainer.removeClass("invisible opacity-0")
        this.loadingContainer.addClass("invisible opacity-0")
        this.ajaxContainer.removeAttr("style")
        this.filterContainer.removeClass('opacity-20')

        // Update the products visible count.
        let count = this.ajaxContainer.find('[data-product-box]').length
        $('[data-product-count]')
            .text(count)
            .parent()
            .removeClass('hidden')

        if (this.products.length > this.productsVisible) {
            $('[data-load-more]').removeClass('hidden')
        } else {
            $('[data-load-more]').addClass('hidden')
        }

        if (!theme.filter.paginating) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // theme.filter.draw_pie_chart()

        // Set the height of the promo box.
        setTimeout(function() {
            theme.filter._promoHeight()
        }, 1000)

    },

    /**
     * * Loading
     */
    loading: function () {

        this.ajaxContainer.addClass("invisible opacity-0")
        this.noResultsContainer.addClass("invisible opacity-0")
        this.filterContainer.addClass('opacity-20')
        this.ajaxContainer.css({
            "min-height": this.loadingContainer.height(),
        })
        this.loadingContainer.removeClass("invisible opacity-0")
        $('[data-product-count]').parent().addClass('hidden')
    },

    /**
     * * No results
     */
    noResults: function () {
        this.loadingContainer.addClass("invisible opacity-0")
        this.noResultsContainer.removeClass("invisible opacity-0")
    },

    /**
     * * Price Range
     */
    price: function () {

        // Logging
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Init price slider (4)', 'color: #f4df2f')
        }

        // Price range element
        this.priceSliders = document.getElementsByClassName("priceSlider")

        let min = Math.floor($('input[name="filter.v.price.gte"]').attr('min'))
        let max = Math.floor($('input[name="filter.v.price.lte"]').attr('max'))
        let start = [
            Math.floor(
                $('input[name="filter.v.price.gte"]').val()
                    ? $('input[name="filter.v.price.gte"]').val()
                    : min
            ),
            Math.floor(
                $('input[name="filter.v.price.lte"]').val()
                    ? $('input[name="filter.v.price.lte"]').val()
                    : max
            ),
        ]

        let options = {
            start: start,
            step: 5,
            connect: true,
            tooltips: {
                to: function (value) {
                    return "£" + Math.round(value)
                },
                from: function (value) {
                    return "£" + Math.round(value)
                },
            },
            range: {
                min: min,
                max: max,
            },
        }

        $.each(this.priceSliders, function() {

            if (this.noUiSlider) {
                this.noUiSlider.destroy()
            }

            noUiSlider.create(this, options)
            this.noUiSlider.on("change", function (values) {
                $('input[name="filter.v.price.gte"]').val(values[0])
                $('input[name="filter.v.price.lte"]').val(values[1])
                $(theme.filter.formNamespace).trigger("submit")
            })
        })

    },

    /**
     * Paginate the results with 'Load more' button
     */
    _paginate: function() {
        let next = (theme.filter.page + theme.filter.productLimit)
        let paginatingResults = true
        theme.filter.page = next
        theme.filter.productsVisible = (theme.filter.productLimit + next)
        theme.filter.run(paginatingResults)
    },

    /**
     * Update the url address bar
     *
     * @returns null
     */
    _updateHistoryState: function(params) {
        // Build the history url for user
        let history = params;
        // Remove the template reference
        history.delete('view')
        // Construct the url from params
        let historyParams = history.toString()
        // Make url
        let historyUrl = theme.filter.collection + "?" + historyParams
        // Update the address bar
        window.history.replaceState(null, null, historyUrl, '')
    },

    /**
     * Get the current filter url
     *
     * @returns The current filter URL
     * @param url - force a url
     */
    _getFilterUrl: function(resetParams) {

        // Standard filter urlk
        let filter = window.location.search

        // Force reset by passing params
        if (resetParams) {
            filter = resetParams
        }

        // Get the params via API for use
        let params = new URLSearchParams(filter)

        if (theme.filter.params && !resetParams) {
            params = new URLSearchParams(theme.filter.params)
        }

        // Set the json view (liquid template to return JSON)
        params.append('view', theme.filter.liquidNamespace)

        // Set the sorting order
        // params.delete('sort_by')
        if (!params.get('sort_by')) {
            params.append('sort_by', theme.filter.sortBy)
        }

        // If the price.gte is empty, remove it
        let priceGte = params.get('filter.v.price.gte')
        if (typeof priceGte === 'string' && priceGte.length === 0) {
            params.delete('filter.v.price.gte')
        }

        // If the price.lte is empty, remove it
        let priceLte = params.get('filter.v.price.lte')
        if (typeof priceLte === 'string' && priceLte.length === 0) {
            params.delete('filter.v.price.lte')
        }

        // Build the url for AJAX endpoint
        let urlParams = params.toString()

        // Update history
        if (!theme.filter.firstRun) {
            theme.filter._updateHistoryState(params)
        }

        // Contruct the URL
        let endpoint = theme.filter.collection + "?" + urlParams

        return endpoint;

    },

    /**
     * Calculate the promo height to line it up with an product image.
     *
     */
    _promoHeight: function() {
        if ($(window).width() < 1024) {
            return false
        }
        let height = $('[data-product-box] img').height()
        $('[data-grid-promo] figure').height(height)
    },

    /**
     * Calculate the filter height for mobile scrolling
     * @returns height (in px)
     */
    _filterHeight: function () {
        let padding = 60
        let height =
            $("[data-filter-track]").innerHeight() -
            ($("[data-filter-track-header]").innerHeight() +
                $("[data-filter-track-footer]").innerHeight())
        return height + padding
    },

}
